import { RangeType } from "./types";

export const satietyScoreRange: RangeType[] = [
  {
    id: "0-39",
    min: 0,
    max: 39,
    title: "< 40",
    payload: "low",
  },
  {
    id: "40-59",
    min: 40,
    max: 59,
    title: "40-59",
    payload: "moderate",
  },
  {
    id: "60-P",
    min: 60,
    max: 100,
    title: "60+",
    payload: "high",
  },
];
